import { ANALYTICS_API_NAME, EVENT_MAPPING, ANALYTICS_EVENT_NAME, REMOVE_KEY_FOR_FOREIGN_COUNTRY, REMOVE_CUSTOM_KEY_EMPTY_VALUE } from '../spnAnalytics/analyticsEnum';
class AppForeGround {

    /**
    * The constructor function is called when the object is created, and it's used to set up the
    * object.
    * @param config @type {Object} - get global class object
    */
    constructor(config) {
        this.config = config;
        this.queueManager = config.queueManager;
        this.isForeignCountry = this.config.isForeignCountry;
        this.removeKeyForeignCountry = REMOVE_KEY_FOR_FOREIGN_COUNTRY;
        this.aspMandateFields = [
            EVENT_MAPPING.app_user_id,
            EVENT_MAPPING.app_device_id,
            EVENT_MAPPING.app_user_agent,
            EVENT_MAPPING.app_event_type,
            EVENT_MAPPING.app_session_id,
            EVENT_MAPPING.app_subscribe_type,
            EVENT_MAPPING.app_platform_type,
            EVENT_MAPPING.app_partner_id,
            EVENT_MAPPING.app_version,
            EVENT_MAPPING.app_build_version,
            EVENT_MAPPING.app_geo_location,
            EVENT_MAPPING.app_hardware,
            EVENT_MAPPING.app_operating_system,
            EVENT_MAPPING.app_profile_id,
            EVENT_MAPPING.app_ppid,
            EVENT_MAPPING.app_sliv_profile_id,
            EVENT_MAPPING.app_user_age,
            EVENT_MAPPING.app_user_gender
        ];
        this.vspMandateFields = [
            EVENT_MAPPING.video_event_type,
            EVENT_MAPPING.video_session_id,
            EVENT_MAPPING.video_network_type,
            EVENT_MAPPING.video_connection_speed,
            EVENT_MAPPING.video_streaming_mode,
            EVENT_MAPPING.video_player_name,
            EVENT_MAPPING.video_player_version,
            EVENT_MAPPING.video_content_format,
            EVENT_MAPPING.video_drm,
            EVENT_MAPPING.video_codec,
            EVENT_MAPPING.video_cdn,
            EVENT_MAPPING.video_session_classifier_experiment_id,
            EVENT_MAPPING.video_delivery_protocol,
            EVENT_MAPPING.video_playing_rate,
            EVENT_MAPPING.video_current_bitrate,
            EVENT_MAPPING.video_time_to_first_byte,
            EVENT_MAPPING.video_resolution,
            EVENT_MAPPING.video_content_id,
            EVENT_MAPPING.video_video_type,
            EVENT_MAPPING.video_length,
            EVENT_MAPPING.normalized_watch_time,
            EVENT_MAPPING.video_position,
            EVENT_MAPPING.video_audio_language,
            EVENT_MAPPING.video_subtitle_language,
            EVENT_MAPPING.video_streaming_host,
            EVENT_MAPPING.video_content_prefetch,
            EVENT_MAPPING.video_binge,
            EVENT_MAPPING.video_18plus,
            EVENT_MAPPING.video_session_start_time,
            EVENT_MAPPING.video_session_watch_time_duration,
            EVENT_MAPPING.video_increment_buffer_time_duration,
            EVENT_MAPPING.video_monetizable_video_views,

            EVENT_MAPPING.video_entry_point,
            EVENT_MAPPING.subscribed_pack_name,
            EVENT_MAPPING.subscribed_pack_resolution,
            EVENT_MAPPING.max_entitled_video_resolution,
            EVENT_MAPPING.initial_video_setting,
            EVENT_MAPPING.updated_video_setting,
            EVENT_MAPPING.is_multicam_asset,
            EVENT_MAPPING.video_parent_id,
            EVENT_MAPPING.video_pt_sp_key,
            EVENT_MAPPING.video_end_reason,
            EVENT_MAPPING.video_playback_state,
            EVENT_MAPPING.video_ssai_id,
            EVENT_MAPPING.ssai_stitcher,
            EVENT_MAPPING.ga_session_id,
        ];
        this.adsMandateFields = [
            EVENT_MAPPING.ads_event_type,
            EVENT_MAPPING.ads_session_id,
            EVENT_MAPPING.ads_campaign_id,
            EVENT_MAPPING.ads_advertiser_id,
            EVENT_MAPPING.ads_current_ad_count,
            EVENT_MAPPING.ads_configured_ad_count,
            EVENT_MAPPING.ads_position,
            EVENT_MAPPING.ads_pod_position,
            EVENT_MAPPING.ads_length_duration,
            EVENT_MAPPING.ads_asset_name,
            EVENT_MAPPING.ads_stream_url,
            EVENT_MAPPING.ads_technology,
            EVENT_MAPPING.ads_system,
            EVENT_MAPPING.ads_advertiser,
            EVENT_MAPPING.ads_creative_id,
            EVENT_MAPPING.ads_stitcher,
            EVENT_MAPPING.ads_is_slate,
            EVENT_MAPPING.ads_media_file_api_framework,
            EVENT_MAPPING.ads_manager_name,
            EVENT_MAPPING.ads_manager_version,
            EVENT_MAPPING.ads_first_ad_system,
            EVENT_MAPPING.ads_first_ad_id,
            EVENT_MAPPING.ads_first_creative_id,
            EVENT_MAPPING.ads_current_bitrate,
            EVENT_MAPPING.ads_session_start_epoch_time,
            EVENT_MAPPING.ads_pod_ad_position,
            EVENT_MAPPING.ads_pod_max_ad_count,
            EVENT_MAPPING.ads_previous_pod,
            EVENT_MAPPING.ads_ad_buffer_duration,
            EVENT_MAPPING.ads_cluster_id,
            EVENT_MAPPING.ads_campaign_name,
            EVENT_MAPPING.ads_watch_time_duration,
            EVENT_MAPPING.ads_ABA_experiment_name,
            EVENT_MAPPING.ads_ABA_experiment_variant_name
        ];
        this.eventMandateFields = [
            EVENT_MAPPING.event_event_type,
            EVENT_MAPPING.event_wall_clock,
            EVENT_MAPPING.event_time_zone,
            EVENT_MAPPING.event_current_playback_rate
        ];
        this.customMandateFields = [];
    }

    /**
     * It checks if the mandatory fields are present in the params object. If not, it assigns an empty
     * string to the missing field.
     * </code>
     * @param params @type {json} - event data
     * @returns An object with 4 properties: asp, event, vsp, and custom_tags.
     */
    checkMandatoryFields(params) {
        this.isForeignCountry = this.config.isForeignCountry;
        let checkCustomKeys = REMOVE_CUSTOM_KEY_EMPTY_VALUE;
        let attr = {};
        attr.asp = {};
        if (this.config?.videoAdStartStatus) {
            attr.adsp = {};
        }
        attr.event = {};
        attr.vsp = {};
        attr.custom_tags = {};

        if (this.isForeignCountry == true) {
            let aspMandateFieldsList = [];
            for (let i = 0; i < this.aspMandateFields.length; i++) {
                if (this.removeKeyForeignCountry.includes(this.aspMandateFields[i])) {
                    delete this.aspMandateFields[i];
                } else {
                    aspMandateFieldsList.push(this.aspMandateFields[i]);
                }
            }
            this.aspMandateFields = aspMandateFieldsList;
        }

        for (let i = 0; i < this.aspMandateFields.length; i++) {
            if (!params.hasOwnProperty(this.aspMandateFields[i])) {
                attr.asp[this.aspMandateFields[i]] = "";
            } else {
                attr.asp[this.aspMandateFields[i]] = params[this.aspMandateFields[i]];
            }
        }

        for (let i = 0; i < this.vspMandateFields.length; i++) {
            if (checkCustomKeys.includes(this.vspMandateFields[i]) && params[this.vspMandateFields[i]] === "") {
                // remove empty custom keys
            } else {
                if (!params.hasOwnProperty(this.vspMandateFields[i])) {
                    attr.vsp[this.vspMandateFields[i]] = "";
                } else {
                    attr.vsp[this.vspMandateFields[i]] = params[this.vspMandateFields[i]];
                }
            }
        }

        if (this.config?.videoAdStartStatus) {
            for (let i = 0; i < this.adsMandateFields.length; i++) {
                if (checkCustomKeys.includes(this.adsMandateFields[i]) && params[this.adsMandateFields[i]] === "") {
                    // remove empty custom keys
                } else {
                    if (!params.hasOwnProperty(this.adsMandateFields[i])) {
                        attr.adsp[this.adsMandateFields[i]] = "";
                    } else {
                        attr.adsp[this.adsMandateFields[i]] = params[this.adsMandateFields[i]];
                    }
                }
            }
        }

        for (let i = 0; i < this.eventMandateFields.length; i++) {
            if (!params.hasOwnProperty(this.eventMandateFields[i])) {
                attr.event[this.eventMandateFields[i]] = "";
            } else {
                attr.event[this.eventMandateFields[i]] = params[this.eventMandateFields[i]];
            }
        }

        for (let i = 0; i < this.customMandateFields.length; i++) {
            if (!params.hasOwnProperty(this.customMandateFields[i])) {
                attr.custom_tags[this.customMandateFields[i]] = "";
            } else {
                attr.custom_tags[this.customMandateFields[i]] = params[this.customMandateFields[i]];
            }
        }

        params.custom_tags = params.custom_tags || {};
        attr.custom_tags = { ...attr.custom_tags, ...params.custom_tags };

        return attr;
    }

    /**
     * If the params object has a property that matches one of the mandatory fields, then add that
     * property to the attr object. If it doesn't, then add an empty string.
     * </code>
     * @param params @type {json} - event data
     * @returns An object with three properties: asp, event, and custom_tags.
     */
    getFireAppForeGroundEvents(eventName, eventData) {
        let attr = this.checkMandatoryFields(eventData);

        attr.asp[EVENT_MAPPING.app_hardware] = attr.asp[EVENT_MAPPING.app_hardware] == "" ? "und" : attr.asp[EVENT_MAPPING.app_hardware];
        attr.asp[EVENT_MAPPING.app_operating_system] = attr.asp[EVENT_MAPPING.app_operating_system] == "" ? "und" : attr.asp[EVENT_MAPPING.app_operating_system];

        if (this.config?.videoAdStartStatus) {
            attr.adsp[EVENT_MAPPING.ads_event_type] = ANALYTICS_EVENT_NAME.VIDEO_APP_FORE_GROUND;
        }

        attr.vsp[EVENT_MAPPING.video_event_type] = ANALYTICS_EVENT_NAME.VIDEO_APP_FORE_GROUND;
        attr.event[EVENT_MAPPING.event_event_type] = ANALYTICS_EVENT_NAME.EVENT_APP_FORE_GROUND;
        /**
          * pass data in local storage
          */
        this.queueManager.nextStoragePostData(ANALYTICS_API_NAME.APP_FORE_GROUND, eventName, attr);
    }
}

export default AppForeGround;